import { TChatBotLikesReq } from "@sharedTypes/req.type";
import { TChatBotLikesRes } from "@sharedTypes/res.type";
import missingParametersError from "api/Error";
import axios from "axios";

export default async function ChatBotLikes(
  chatMessageId: string,
  liked: boolean,
  disliked: boolean,
) {
  const apiUrl = "/tools/chatbot/chatbotLikes";

  const body: TChatBotLikesReq = {
    id: chatMessageId,
    liked,
    disliked,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TChatBotLikesRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });
  return data;
}
